var Accordion = function($element, options){
    this.element = $element;

    this.defaults = {
        singleActiveItem: false,
        activeIndex: undefined,
        fromWidth: 0,
    };
    this.options = jQuery.extend({}, this.defaults, options);

    this.items = this.element.find('> [data-role="accordion-item"]');
    
    if (this.items.length) {
        this.init();
    }
};

Accordion.prototype = {
    defaults: {},
    windowWidth: undefined,
    init: function ()
    {
        this.windowWidth = window.innerWidth;

        if (this.options.activeIndex != undefined) {
            var item = $(this.items[this.options.activeIndex]);
            this.activate(item);
        }

        this.addDOMEvents();
    },
    addDOMEvents: function() {
        var _self = this;

        this.items.children('[data-role="accordion-title"]').on('click', function() {
            if (!_self.options.fromWidth || (_self.options.fromWidth && _self.options.fromWidth >= _self.windowWidth)) {
                var item = $(this).closest('[data-role="accordion-item"]');
                _self.activate(item);
            }
        });

        $(document).on('airport.window_width_changed', function() {
            _self.windowWidth = windowWidth;
        });

        if (typeof _self.options.fromWidth !== 'undefined') {
            var resizeFn = debounce(function () {
                if (_self.windowWidth != window.innerWidth) {
                    _self.windowWidth = window.innerWidth;

                    if (_self.windowWidth > _self.options.fromWidth) {
                        _self.remove();
                    }
                }
            }, 100);

            window.addEventListener('resize', resizeFn);
        }
    },
    activate: function(item) {

        var _self = this;
        
        var act = item;
        if (act) {
            if (this.options.singleActiveItem) {
                this.element.find('.active').removeClass('active');
                setTimeout(function() {
                    item.toggleClass('active').children('[data-role="accordion-content"]').slideToggle();
                }, 500);
            }
            else {
                item.toggleClass('active').children('[data-role="accordion-content"]').slideToggle()
            }
        }
    },
    remove: function() {
        this.items.each(function(){
            
            $(this).find('[data-role="accordion-content"]').removeAttr('style');
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
            }
        })
    }
};
